export class ConditionsChecker {
    private list: Record<string, boolean>;
    private onFail: (conditionsScope: string, list: Record<string, boolean>) => void;

    constructor(onFail: (conditionsScope: string, list: Record<string, boolean>) => void) {
        this.list = {};
        this.onFail = onFail;
    }

    check(conditionsScope: string): boolean {
        const result = Object.values(this.list).includes(true);
        if (result) {
            this.onFail(conditionsScope, this.list);
        }
        return !result;
    }

    add(newConditions: Record<string, boolean>): void {
        this.list = {
            ...this.list,
            ...newConditions,
        };
    }

    addWithCheck(conditionsScope: string, newConditions: Record<string, boolean>): boolean {
        this.add(newConditions);
        return this.check(conditionsScope);
    }

    getList(): Record<string, boolean> {
        return this.list;
    }
}
